import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "space-around",
    backgroundColor: "#54b0f3",
    height: 40,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
});

function ControllerFrame(props) {
  const { children } = props;
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
}

export default ControllerFrame;
